module.exports = __webpack_public_path__ + "img/zhibotu.b9bd2411.jpg";